<template>
  <div class="home">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>在线订票</el-breadcrumb-item>
        <el-breadcrumb-item>支付成功</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="public-w pay-success">
      <img
        class="icon-sucess"
        src="../../assets/images/icon-sucess.png"
        alt=""
      />
      <div class="text">购买成功</div>
      <el-button type="primary" size="medium" round class="btn">
        查看订单
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.pay-success {
  margin-top: 24px;
  margin-bottom: 24px;
  padding: 130px 0;
  .icon-sucess {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
  }
  .text {
    margin-bottom: 24px;
    color: #31a775;
    font-size: 20px;
    line-height: 24px;
  }
  .btn {
    border-color: #31a775;
    background-color: #31a775;
    box-shadow: 0 2px 8px 0 rgba(2, 190, 110, 0.2);
  }
}
</style>
